import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';

// Pages
import HomePage from './pages/HomePage';
import AccueilDomicile from './pages/AccueilDomicile';
import AccueilNew from './pages/AccueilNew';
import AccueilDomicilePc from './pages/AccueilDomicilePc';
import ReparationInformatique from './pages/ReparationInformatique';
import Ordinateur from './pages/Ordinateur';
import ReparationPc from './pages/ReparationPc';
import Cours from './pages/Cours';
import ReparationOrdinateur from './pages/ReparationOrdinateur';
import OrdinateurReparation from './pages/OrdinateurReparation';
import ForfaitsWindows from './pages/ForfaitsWindows';
import OrdinateurImprimante from './pages/OrdinateurImprimante';
import LoireAtlantique from './pages/LoireAtlantique';

// Blog Pages
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';

// Outils / Affiliation Pages
import OutilsPage from './pages/OutilsPage';
import OutilsPostPage from './pages/OutilsPostPage';
import ForfaitsUrgence from './pages/ForfaitsUrgence';
import DepannageInformatique from './pages/DepannageInformatique';
import ReconditionnementOrdinateur from './pages/ReconditionnementOrdinateur';
import DiagnosticAssistance from './pages/DiagnosticAssistance';
import MicroSoudurePlasturgie from './pages/MicroSoudurePlasturgie';
import ReparationDomicile from './pages/ReparationDomicile';
import DiagnosticTechnicien from './pages/DiagnosticTechnicien';
import ForfaitsFormation from './pages/ForfaitsFormation';
import RecuperationDonnees from './pages/RecuperationDonnees';
import Bureautique from './pages/Bureautique';
import DiagnosticAide from './pages/DiagnosticAide';
import Domaines from './pages/Domaines';
import ZoneIntervention from './pages/ZoneIntervention';
import MaximeHuet from './pages/MaximeHuet';
import PlanDuSite from './pages/PlanDuSite';
import Contact from './pages/Contact';
import MentionsLegales from './pages/MentionsLegales';
import NotFound from './pages/NotFound';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Header />
          <main className="main-content">
            <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/accueil/domicile/" element={<AccueilDomicile />} />
            <Route path="/accueil-new/" element={<AccueilNew />} />
            <Route path="/accueil/domicile/pc/" element={<AccueilDomicilePc />} />
            <Route path="/reparation/informatique/" element={<ReparationInformatique />} />
            <Route path="/ordinateur/" element={<Ordinateur />} />
            <Route path="/reparation/pc/" element={<ReparationPc />} />
            <Route path="/accueil/domicile/ordinateur/domaines/cours/" element={<Cours />} />
            <Route path="/reparation/ordinateur/" element={<ReparationOrdinateur />} />
            <Route path="/ordinateur/reparation/" element={<OrdinateurReparation />} />
            <Route path="/accueil/domicile/ordinateur/forfaits/windows/" element={<ForfaitsWindows />} />
            <Route path="/ordinateur/imprimante/" element={<OrdinateurImprimante />} />
            <Route path="/accueil/domicile/loire-atlantique/" element={<LoireAtlantique />} />
            <Route path="/accueil/domicile/ordinateur/forfaits/urgence/" element={<ForfaitsUrgence />} />
            <Route path="/depannage-informatique/" element={<DepannageInformatique />} />
            <Route path="/reconditionnement-dordinateur/" element={<ReconditionnementOrdinateur />} />
            <Route path="/accueil/domicile/ordinateur/diagnostic/assistance/" element={<DiagnosticAssistance />} />
            <Route path="/micro-soudure-et-plasturgie/" element={<MicroSoudurePlasturgie />} />
            <Route path="/reparation/domicile/" element={<ReparationDomicile />} />
            <Route path="/accueil/domicile/ordinateur/diagnostic/technicien/" element={<DiagnosticTechnicien />} />
            <Route path="/accueil/domicile/ordinateur/forfaits/formation/" element={<ForfaitsFormation />} />
            <Route path="/recuperation-de-donnees/" element={<RecuperationDonnees />} />
            <Route path="/accueil/domicile/loire-atlantique/bureautique/" element={<Bureautique />} />
            <Route path="/accueil/domicile/ordinateur/diagnostic/aide/" element={<DiagnosticAide />} />
            <Route path="/accueil/domicile/ordinateur/domaines/" element={<Domaines />} />
            <Route path="/accueil/domicile/ordinateur/zone/" element={<ZoneIntervention />} />
            <Route path="/accueil/maxime-huet-technicien-en-depannage-informatique/" element={<MaximeHuet />} />
            <Route path="/plan-du-site" element={<PlanDuSite />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />

            {/* Routes du blog */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:id" element={<BlogPostPage />} />

            {/* Routes outils / affiliation */}
            <Route path="/outils" element={<OutilsPage />} />
            <Route path="/outils/:category/:id" element={<OutilsPostPage />} />
            
            {/* Route 404 - doit être en dernier */}
            <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
